import { useQuery } from '@apollo/client'

function useClientQuery(query, options = {}) {
  const newOptions = { fetchPolicy: 'cache-only', ...options }

  return useQuery(query, newOptions)
}

export default useClientQuery
